
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherItemDetailsSelectGrid extends _Ext.GridBase<Common.GiftVoucherTransactionsRow, any> {
        protected getColumnsKey() { return 'Common.GiftVoucherTransactions'; }
        protected getIdProperty() { return Common.GiftVoucherTransactionsRow.idProperty; }
        protected getInsertPermission() { return Common.GiftVoucherTransactionsRow.insertPermission; }
        protected getLocalTextPrefix() { return Common.GiftVoucherTransactionsRow.localTextPrefix; }
        protected getService() { return Common.GiftVoucherTransactionsSelectService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {};
          
        //withBom: boolean;
        constructor(container: JQuery, options) {
            super(container, options); 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): Common.GiftVoucherTransactionsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }



        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }


    }
}